/* eslint-disable @typescript-eslint/no-explicit-any */
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';
import { Router } from '@angular/router';
import { CommmonService } from 'src/app/utils/common.service';
import { ReporteService } from 'src/app/home/services/reporte.service';
import { RptDetalleSolicitudesUsuarios } from './rpt_det_sol_usuarios.interface';
import { PageStateService } from 'src/app/components/paginator/page-state.service';
import { RequestUtilsService } from '../benefit-application/utils/request-admin-utils.service';
import { RequestsService } from 'src/app/home/services/requests.service';


@Component({
  selector: 'app-tab-profiles',
  templateUrl: './tab-profiles.component.html',
  styleUrls: ['./tab-profiles.component.scss'],
})
export class TabProfilesComponent implements OnInit {
  @ViewChild(PaginatorComponent, { static: false }) childC!: PaginatorComponent;
  isSizeMobile = false;
  @ViewChild(MatSort) sort!: MatSort;
  selectedSortOption = 'order';
  paginatedSolicitudes!: any[];
  rpt_detalle_solicitudes_usuarios!: RptDetalleSolicitudesUsuarios[];
  currentPage = 1;
  totalPages!: number;
  itemsPerPage = 10;
  totalRows!: number;
  isLoaded: boolean = false;
  isLoadedReport: boolean = false;
  criterio_busqueda!: string;
  columnsGrid: string[] = [
    'rut',
    'nombre_completo',
    'Email',
    'beneficio_solicitado',
    'monto_solicitado',
    'monto_maximo_beneficio',
    'cuotas',
    'fecha_solicitud',
    'fecha_aprobacion',
    'estado_nombre',
    'acciones'
  ];
  searchTerm!: string;
  formattedDate: string | null = '';
  selectedStartDate: Date | null = null;
  selectedEndDate: Date | null = null;
  selectedHourInicio: number | null = null;
  selectedHour: number | null = null;
  hours: number[] = [];
  startDateString = ''; // String formateado de la fecha de inicio
  endDateString = ''; // String formateado de la fecha de fin
  popupVisible: boolean = false;
  archivos: string[] = [];
  popupConfirmAnularVisible: boolean = false;
  solicitud_id: number = 0
  primer_aprobador: string = '';
  fecha_primera_aprobacion: string = '';
  segundo_aprobador: string = '';
  fecha_segunda_aprobacion: string = '';

  constructor(
    public dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
    private _liveAnnouncer: LiveAnnouncer,
    private commonService: CommmonService,
    private reporte_service: ReporteService,
    private pageStateService: PageStateService,
    private request_util_service: RequestUtilsService,
    private request_service: RequestsService
  ) {
  }

  async ngOnInit(): Promise<void> {
    const formatear = (d: Date) =>
      `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;

    const parseLocalDate = (fechaStr: string): Date => {
      const [yyyy, mm, dd] = fechaStr.split('-').map(Number);
      return new Date(yyyy, mm - 1, dd); // MES es base 0
    };

    const [fecha_inicio_str] = [new Date(), new Date(Date.now() - 3 * 86400000)].map(formatear);

    this.selectedStartDate = parseLocalDate(fecha_inicio_str);
    this.selectedEndDate = parseLocalDate(fecha_inicio_str);

    await this.listar_detalle_solicitudes_usuarios(fecha_inicio_str, fecha_inicio_str);

    const sizeMobile = this.breakpointObserver.observe(['(max-width: 768px)']);
    sizeMobile.subscribe((lay) => {
      this.isSizeMobile = lay.breakpoints['(max-width: 768px)'];
    });
  }

  async listar_detalle_solicitudes_usuarios(fecha_inicio: string = "", fecha_termino: string = "", criterio_busqueda: string = "", pagina: Number = 1) {
    this.isLoaded = true;
    criterio_busqueda = this.criterio_busqueda === undefined ? "-" : this.criterio_busqueda;
    const solicitudes_usuarios = await this.reporte_service.listar_detalle_solicitudes_usuarios(fecha_inicio, fecha_termino, criterio_busqueda, pagina);
    this.isLoaded = false;
    this.rpt_detalle_solicitudes_usuarios = JSON.parse(solicitudes_usuarios.data);
    this.totalPages = solicitudes_usuarios.pages;
    this.totalRows = solicitudes_usuarios.total_data;
    this.currentPage = solicitudes_usuarios.current_page;
  }

  formatDate(isoDate: string): string {
    const date = new Date(isoDate);
    return date.toISOString().split('T')[0];
  }


  async searchFilter() {
    const fecha_inicio = this.commonService.formatear_fecha(this.selectedStartDate?.toISOString());
    const fecha_termino= this.commonService.formatear_fecha(this.selectedEndDate?.toISOString());
    if(this.searchTerm === "") { await this.listar_detalle_solicitudes_usuarios(fecha_inicio, fecha_termino); }
    if (this.searchTerm.length >= 3) {
      this.paginatedSolicitudes = this.rpt_detalle_solicitudes_usuarios.filter(
        (solicitud) =>
          solicitud.nombre_completo
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .includes(this.searchTerm.toLowerCase()) ||
          solicitud.estado_nombre
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .includes(this.searchTerm.toLowerCase()) ||
          solicitud.nombre_completo.toLowerCase().includes(this.searchTerm.toLowerCase()),
      );
      this.pageStateService.searchName = this.searchTerm;
      this.pageStateService.searchActive = true;
      this.totalPages = Math.ceil(
        this.rpt_detalle_solicitudes_usuarios.length / this.itemsPerPage,
      );
      this.paginateCards(1, this.paginatedSolicitudes);
      if (this.rpt_detalle_solicitudes_usuarios.length === 0) {
        this.paginateCards(1, this.paginatedSolicitudes);
      }
    } else {
      this.totalPages = Math.ceil(this.paginatedSolicitudes.length / this.itemsPerPage);
      this.paginateCards(1, this.paginatedSolicitudes);
      this.pageStateService.searchName = this.searchTerm;
      this.pageStateService.searchActive = false;
    }
    this.childC.getNumberPagesPaginator(this.currentPage, this.totalPages);
  }

  async buscar_solicitudes() {
    const fecha_inicio = this.commonService.formatear_fecha(this.selectedStartDate?.toISOString());
    const fecha_termino= this.commonService.formatear_fecha(this.selectedEndDate?.toISOString());
    await this.listar_detalle_solicitudes_usuarios(fecha_inicio, fecha_termino);
  }

  async descargar_reporte_detalle_solicitudes_usuarios() {
    this.isLoadedReport = true;
    const response = await this.reporte_service.generar_rpt_detalle_solicitudes_usuarios();
    this.isLoadedReport = false;
    const bom = '\uFEFF'; // Optional, mejora acentos/tildes en Excel
    const blob = new Blob([bom + response], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'reporte.csv';
    a.click();

    window.URL.revokeObjectURL(url);
  }

  pageChange(page: Number) {
    this.onPageChange(page);
  }

  async onPageChange(page: any) {
    const fecha_inicio = this.commonService.formatear_fecha(this.selectedStartDate?.toISOString());
    const fecha_termino= this.commonService.formatear_fecha(this.selectedEndDate?.toISOString());
    await this.listar_detalle_solicitudes_usuarios(fecha_inicio, fecha_termino, "", page);
    console.log(this.rpt_detalle_solicitudes_usuarios, "datos")
    this.currentPage = page;
  }

  async on_change_button(solicitud_id: number) {
    await this.request_service.cambiar_estado_solicitud(solicitud_id);
  }

  paginateCards(page: number, rpt_detalle_solicitudes_usuarios: any[]) {
      this.currentPage = page;
      this.rpt_detalle_solicitudes_usuarios = rpt_detalle_solicitudes_usuarios.slice(
        (page - 1) * this.itemsPerPage,
        page * this.itemsPerPage,
      );
    }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  abrirPopup(element: any) {
    this.archivos = element.archivos;
    this.primer_aprobador = element.primer_aprobador;
    this.fecha_primera_aprobacion = element.fecha_primera_aprobacion;
    this.segundo_aprobador = element.segundo_aprobador;
    this.fecha_segunda_aprobacion = element.fecha_segunda_aprobacion;
    this.popupVisible = true;
    document.body.style.overflow = 'hidden'; // Bloquea scroll del body
  }

  cerrarPopup() {
    this.popupVisible = false;
    document.body.style.overflow = 'auto'; // Restaura scroll
  }

  abrir_popup_confirmacion(solicitud_id: number) {
    this.solicitud_id = solicitud_id;
    this.popupConfirmAnularVisible = true;
  }

  async confirmar_anulacion() {
    this.rpt_detalle_solicitudes_usuarios = [];
    await this.on_change_button(this.solicitud_id);

    const fecha_inicio = this.commonService.formatear_fecha(this.selectedStartDate?.toISOString());
    const fecha_termino= this.commonService.formatear_fecha(this.selectedEndDate?.toISOString());
    await this.listar_detalle_solicitudes_usuarios(fecha_inicio, fecha_termino);

    this.popupConfirmAnularVisible = false;
  }

  cerrar_anulacion() {
    this.popupConfirmAnularVisible = false;
  }

  async descargar_archivo(archivo: string = ""){
    const url = await this.request_util_service.download_file(archivo);
    this.download(url.download_url)
  }

  download(url: any) {
    const a = document.createElement('a');
    a.setAttribute('target', '_blank');
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
